import { useEffect, useState } from "react";

const AccessDeniedBanner = () => {
  const [warning, setWarning] = useState("");

  const loadWarning = () => {
    const data = JSON.parse(
      localStorage.getItem("accessDeniedWarning") || "null"
    );

    if (!data) {
      setWarning("");
      return;
    }

    setWarning(data.message);
  };

  const handleClose = () => {
    localStorage.removeItem("accessDeniedWarning");
    setWarning("");
  };

  useEffect(() => {
    loadWarning();

    window.addEventListener("access-denied", loadWarning);

    return () =>
      window.removeEventListener(
        "access-denied",
        loadWarning
      );
  }, []);

  if (!warning) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 60,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 999999,
        background: "#fff3cd",
        color: "#856404",
        border: "1px solid #ffeeba",
        borderRadius: "6px",
        padding: "10px 16px",
        fontWeight: 600,
        boxShadow: "0 4px 12px rgba(0,0,0,.15)",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: "320px",
      }}
    >
      <span style={{ flex: 1 }}>
        ⚠ {warning}
      </span>

      <button
        onClick={handleClose}
        style={{
          border: "none",
          background: "transparent",
          fontSize: "18px",
          cursor: "pointer",
          color: "#856404",
          fontWeight: "bold",
        }}
      >
        ×
      </button>
        
    </div>
  );
};

export default AccessDeniedBanner;